var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 19,
    rx: 1,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_44_3142",
    transform: "translate(-0.0137755) scale(0.0193878 0.0285714)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_44_3142",
    width: 53,
    height: 35,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAjCAYAAAA0aUL2AAAABHNCSVQICAgIfAhkiAAAAiZJREFUWEdj/PTp03+G4QW+M456amjE6HfGPcefDavkx8jw/ycjj9WeYeUpDjYmhlFPDYUsNXxj6vGz98MqTzEw/KdfPXXl7lcGHWVueqRg+njqw+c/DJaJlxhWd6rTw2P08VR+zz2Gq/e+MTAyMjDsnqpD69iivaeOXfzEkNR0m+HEAn2GZCDtYSXIkBooQUuPUddToGTmln2V4cmrnyQ5ujFdjpoepa6nQD5ZuesNQ8OsRwxza1UYth97z3D88meGJqCjYQAkduLKZ4bGNDmGlbvfgJPlnmlUTZLU9xTI8cGl1xms9PkY5mx4CfYciA0DsNhszJBjKOq7T4vCgzaeAhXfoGQY6iLCMLFECSMpgmILlL+S/cUZmjPlSUqqRCimjacevfjJYJFwEaenQIVHSPkNhuIYaTCmMqCNp0DJT0uJi2H1njcMa7o0MOoms7iLwIJBnKF3yVOs8hR6kvqeAiWt+hmPGE4t0meYvf4Fw87jH8AOhwGQR0AxtbZbE6s8hR4Caae+p0CxQGqR3l+kxBDuJkIF/4CNoL6n0F0GipWC3vsMu6ZqgwsHUElIg3yEbC3tPQWyLbHxFsPnr/8YQAUIKFnSGNDHUyDPuGVfYZhXp4pSZ9HIc/TxFMjxw67rQaMYwWXsd0Y+m+E1msTJPjqaROdERKZ1w3c0aeWOh8NqNImJkeHn6KwHmcmc3troV/nS0WffGT9//ixKRwtpbtV/IAAA/Zs6ShNujekAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIl);
export default __webpack_public_path__ + "static/media/il.053c1d841350f5f301c82ec011863419.svg";
export { ForwardRef as ReactComponent };